import { AxiosResponse } from 'axios';
import { useCallback } from 'react';
import { useQuery } from 'react-query';
import API from '../api';
import { PopUp } from '../types/popup';

export const usePopUp = () => {
  const { data, isLoading } = useQuery(
    ['popUp', 'one'],
    async () => await API.getPopUp(),
    {
      select: useCallback((data: AxiosResponse<PopUp>) => {
        const popUp = data.data;
        if (!popUp) return;
        return {
          popUp: {
            ...popUp,
          },
        };
      }, []),
    }
  );
  if (isLoading || !data) {
    return {
      popUp: {} as PopUp,
    };
  }

  return {
    ...data,
  };
};
